<template>
  <div class="achivements-component">
    <div class="area">
      <div
        class="row achivements-container"
        v-animated-show="utils.handleScroll"
      >
        <h1 v-html="title" class="component-title col-12 centered"></h1>
        <div class="achivements-list col-12 col-md-12" ref="animated">
          <section
            class="list-section-banner"
            v-for="(l, i) in list"
            :key="i"
            :class="[
              {
                current: current === i,
                'animated-banner': list.length > 1,
              },
            ]"
            :style="{
              transform: translate,
            }"
          >
            <div class="row">
              <div class="spacer col-1 md-hidden"></div>
              <div class="content col-5 col-md-12">
                <Description
                  class="mini icon-top icon-top-small"
                  :isMoreTop="true"
                  :title="l.title"
                  :desc="l.desc"
                  v-if="l.title"
                />
              </div>
              <div class="art col-6 col-md-12">
                <div class="crumbs"></div>
                <img :src="l.img.src" :alt="l.img.alt" />
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../utils";
export default {
  name: "Recipes",
  props: {
    title: String,
    list: Array,
  },
  data() {
    return {
      utils: utils,
      current: 0,
    };
  },
  computed: {
    translate() {
      return `translateX(-${this.currentBanner * 100}%)`;
    },
  },
  methods: {
    selectNav(index) {
      this.current = (index + this.list.length) % this.list.length;
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.$refs.animated) {
        this.$refs.animated.classList.add("animated");
      }
    }, 1000);
  },
};
</script>

<style lang="scss">
.achivements-component {
  @extend %page-block;
  padding-bottom: 0;
  .row-offset {
    @media all and (max-width: $md) {
      grid-gap: 26px;
    }
  }
  .achivements-container {
    @media all and (max-width: $md) {
      grid-row-gap: 6px;
    }

    display: grid;
    grid-row-gap: 46px;
  }
  h1 {
    margin-top: 0px;
  }
  .achivements-list {
    @media all and (max-width: $md) {
      grid-row-gap: 36px;
    }
    display: grid;

    .list-section-banner {
      .content {
        @media all and (max-width: $md) {
          grid-column: 1 / span 12;
          margin-top: 25px;
          text-align: center;
        }
        margin-top: 100px;
        .title {
          @media all and (max-width: $md) {
            margin-right: 25px;
            margin-left: 25px;
          }
          .indent {
            text-indent: -9px;
          }
        }
      }
      .description.mini {
        .desc {
          line-height: 1.5em;
        }
      }

      .art {
        @media all and (max-width: $md) {
          grid-column: 1 / span 12;
          grid-row: 1;
          mask-size: contain;
          background-size: cover;
          height: 280px;
          max-height: 280px;
          margin-left: 0;
          margin-top: 0;
          justify-content: center;
          justify-self: center;
          max-width: 240px;
        }
        height: 514px;
        position: relative;
        align-items: stretch;
        align-self: flex-start;
        display: grid;
        margin-left: 26px;
        margin-top: 0px;

        justify-content: center;
        &:before {
          @media all and (max-width: $md) {
            width: 210px;
            height: 210px;
          }
          display: block;
          width: 330px;
          height: 330px;
          position: absolute;
          left: 0;
          transform: translate(0, -50%);
          top: 50%;
          background: $bg-grey-dark;
          border-radius: 50%;
          content: "";
          z-index: 1;
        }
        &:after {
          @media all and (max-width: $md) {
            width: 146px;
            height: 146px;
            left: 75px;
            transform: translate(0, -75%);
          }
          display: block;
          width: 230px;
          height: 230px;
          position: absolute;
          left: 114px;
          transform: translate(0, -79%);
          top: 50%;
          background: $color-accent;
          border-radius: 50%;
          content: "";
          z-index: 0;
        }
        img {
          z-index: 1;
          @media all and (max-width: $md) {
            max-height: 250px;
            align-self: stretch;
            object-fit: contain;
          }
          object-fit: contain;
          max-width: 100%;
          width: 300px;
          max-height: 400px;
        }
      }
      &:nth-child(2n - 1) {
        .content {
          @media all and (max-width: $md) {
            grid-column: 1 / span 12;
            grid-row: 2;
            margin-left: 0;
            margin-right: 0;
          }
          grid-row: 1;
          grid-column: 8 / span 3;
          margin-left: 0;
          margin-right: -26px;
        }
        .art {
          @media all and (max-width: $md) {
            grid-column: 1 / span 12;
            grid-row: 1;
            margin-left: 0;
            margin-right: 0;
          }
          grid-row: 1;
          grid-column: 2 / span 5;
          margin-left: -26px;
        }
      }
      &:nth-child(2n) {
        .content {
          @media all and (max-width: $md) {
            grid-column: 1 / span 12;
            grid-row: 2;
            margin-left: 0;
            margin-right: 0;
          }
          grid-row: 1;
          grid-column: 3 / span 3;
          margin-left: 0;
          margin-right: -26px;
        }
        .art {
          @media all and (max-width: $md) {
            grid-column: 1 / span 12;
            grid-row: 1;
            margin-left: 0;
            margin-right: 0;
          }
          grid-row: 1;
          grid-column: 8 / span 4;
          margin-left: -26px;
          &::before {
            right: 0;
            transform: translate(0, -51%);
            left: unset;
            top: 40%;
          }
          &::after {
            left: 0;
            transform: translate(0, -18%);
            top: 44%;
          }
          img {
            justify-self: flex-end;
            align-self: flex-start;
            left: 0px;
            position: relative;
          }
          .crumbs {
            left: -120px;
            transform: scaleX(-1);
          }
        }
      }
    }
    &.animated {
      .list-section-banner {
        visibility: visible;
      }
    }
  }
}
</style>
